import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const isDev = process.env.NODE_ENV === 'development';

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f7f6',
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        padding: 24,
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 16,
          padding: '48px 40px',
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 24px rgba(0, 135, 74, 0.08)',
          border: '1px solid #e0f0e7',
        }}>
          <div style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: '#e6f4f4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: 32,
          }}>
            !
          </div>

          <h1 style={{
            fontSize: 24,
            fontWeight: 700,
            color: '#1a2b2b',
            margin: '0 0 8px',
          }}>
            Algo deu errado
          </h1>

          <p style={{
            fontSize: 15,
            color: '#5f7a7a',
            margin: '0 0 24px',
            lineHeight: 1.5,
          }}>
            Ocorreu um erro inesperado. Tente recarregar a página ou voltar ao início.
          </p>

          {isDev && this.state.error && (
            <pre style={{
              textAlign: 'left',
              background: '#f8fafa',
              border: '1px solid #e0f0e7',
              borderRadius: 8,
              padding: 16,
              fontSize: 12,
              color: '#c0392b',
              overflow: 'auto',
              maxHeight: 160,
              marginBottom: 24,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>
              {this.state.error.toString()}
            </pre>
          )}

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 24px',
                backgroundColor: '#00874a',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Recarregar página
            </button>

            <a
              href="/"
              style={{
                padding: '10px 24px',
                backgroundColor: 'transparent',
                color: '#00874a',
                border: '1px solid #00874a',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                textDecoration: 'none',
                display: 'inline-block',
              }}
            >
              Voltar ao início
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
